module.exports = __webpack_public_path__ + "static/fonts/Roboto-Thin.954bbde.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Thin.woff2
// module id = 323
// module chunks = 1